import { gql } from 'graphql-request'

export const UPDATE_BOOK_REPORT = gql`
  mutation UpdateBookReport($updateBookReportInput: UpdateBookReportInput!) {
    updateBookReport(updateBookReportInput: $updateBookReportInput) {
      id
    }
  }
`
